import { createContext } from 'react';

export const Context = createContext({
    sidebarCollapsed: false,
    handleToggleClick: () => console.log("abc"),
});
